var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnquiryblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.39111,
    r: 7.55,
    stroke: "black",
    strokeWidth: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84456 5.73214C9.84456 6.80414 8.97553 7.67317 7.90353 7.67317C6.83153 7.67317 5.9625 6.80414 5.9625 5.73214C5.9625 4.66014 6.83153 3.79111 7.90353 3.79111C8.97553 3.79111 9.84456 4.66014 9.84456 5.73214Z",
    stroke: "black",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 12.7554C12.0059 12.2306 11.9069 11.7098 11.7087 11.2231C11.5104 10.7365 11.2168 10.2937 10.8447 9.92046C10.4727 9.54719 10.0297 9.25084 9.54142 9.04859C9.05311 8.84633 8.52918 8.74219 8 8.74219C7.47082 8.74219 6.94689 8.84633 6.45858 9.04859C5.97027 9.25084 5.52727 9.54719 5.15525 9.92046C4.78324 10.2937 4.48959 10.7365 4.29134 11.2231C4.09308 11.7098 3.99414 12.2306 4.00027 12.7554",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73242 11.585L9.07345 11.585",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiryblack);
export default __webpack_public_path__ + "static/media/enquiryblack.2e0154f16794eb7e4b497d36ac3c99a7.svg";
export { ForwardRef as ReactComponent };